import { render, staticRenderFns } from "./TreatmentOfferCreatedTimelineSection.vue?vue&type=template&id=5f7c23ec&scoped=true"
import script from "./TreatmentOfferCreatedTimelineSection.vue?vue&type=script&lang=js"
export * from "./TreatmentOfferCreatedTimelineSection.vue?vue&type=script&lang=js"
import style0 from "./TreatmentOfferCreatedTimelineSection.vue?vue&type=style&index=0&id=5f7c23ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7c23ec",
  null
  
)

export default component.exports